// Scrappy test-only pages, not synced from Plasmic. Purpose: give the
// Desktop State Manager System (DesktopStateProvider, wired once above the
// Router in App.js) four distinct routes to navigate between, so we can
// verify that window/dock state (open, focus, position, size) survives
// client-side navigation instead of resetting on every route change.
//
// Each page renders the same live Desktop (CustomComponentTestPage - the
// Plasmic-authored Window Manager Surface + Dock) plus a small fixed
// corner banner/nav so it's obvious at a glance which "page" is showing.
// Safe to delete once persistence has been verified.
import React from "react";
import { Link, useLocation } from "react-router-dom";
import CustomComponentTestPage from "./CustomComponentTestPage";

const TEST_ROUTES = [
  { path: "/test-1", label: "Test 1" },
  { path: "/test-2", label: "Test 2" },
  { path: "/test-3", label: "Test 3" },
  { path: "/test-4", label: "Test 4" },
];

// Real Plasmic-designed pages, shown beside the scrappy test links so you
// can navigate from a test page to actual content and confirm Desktop
// state (open windows, position, focus) still survives.
const REAL_ROUTES = [
  { path: "/community", label: "Community Home" },
  { path: "/community/forum", label: "Community Forum" },
  { path: "/text-trigger-test", label: "Text Trigger Test" },
];

function TestNav() {
  const location = useLocation();
  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        zIndex: 99999,
        display: "flex",
        gap: 12,
        padding: "10px 16px",
        background: "rgba(20,20,22,0.85)",
        borderBottomLeftRadius: 10,
        fontFamily: "sans-serif",
        fontSize: 13,
      }}
    >
      {TEST_ROUTES.map((r) => (
        <Link
          key={r.path}
          to={r.path}
          style={{
            color: location.pathname === r.path ? "#7dd3fc" : "#fff",
            textDecoration: "none",
            fontWeight: location.pathname === r.path ? 700 : 400,
          }}
        >
          {r.label}
        </Link>
      ))}
      <span style={{ color: "rgba(255,255,255,0.3)" }}>|</span>
      {REAL_ROUTES.map((r) => (
        <Link
          key={r.path}
          to={r.path}
          style={{
            color: location.pathname === r.path ? "#86efac" : "#fff",
            textDecoration: "none",
            fontWeight: location.pathname === r.path ? 700 : 400,
          }}
        >
          {r.label}
        </Link>
      ))}
      <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>
        Home
      </Link>
    </nav>
  );
}

function TestPage({ label, accent }) {
  return (
    <>
      <TestNav />
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 99999,
          padding: "10px 16px",
          maxWidth: 380,
          background: accent,
          color: "#111",
          fontFamily: "sans-serif",
          fontWeight: 700,
          fontSize: 13,
          lineHeight: 1.4,
          borderBottomRightRadius: 10,
        }}
      >
        {label} — open/move a window here, then click another Test link
        above and come back. Position, focus and open state should be
        exactly as you left them.
      </div>
      <CustomComponentTestPage />
    </>
  );
}

export function TestPageOne() {
  return <TestPage label="Test Page 1" accent="#fca5a5" />;
}
export function TestPageTwo() {
  return <TestPage label="Test Page 2" accent="#93c5fd" />;
}
export function TestPageThree() {
  return <TestPage label="Test Page 3" accent="#86efac" />;
}
export function TestPageFour() {
  return <TestPage label="Test Page 4" accent="#fde68a" />;
}
